(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    
  (function () {
    function initVpxCollectionReveal() {
      var items = document.querySelectorAll('.section-resource-list .resource-list__item');
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) return;

      items.forEach(function (item, i) {
        item.classList.add('vpx-pre-reveal');
        item.style.transitionDelay = Math.min(i * 60, 360) + 'ms';
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('vpx-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      items.forEach(function (item) { observer.observe(item); });

      setTimeout(function () {
        items.forEach(function (item) { item.classList.add('vpx-visible'); });
      }, 2500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVpxCollectionReveal);
    } else {
      initVpxCollectionReveal();
    }
    document.addEventListener('shopify:section:load', initVpxCollectionReveal);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorynex-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVpxCarousel(root) {
      if (root.dataset.vpxInit === '1') return;
      root.dataset.vpxInit = '1';

      var stage = root.querySelector('[data-vpx-stage]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-vpx-item]'));
      if (!stage || !items.length) return;

      var dotsWrap = root.querySelector('[data-vpx-dots]');
      var prevBtn = root.querySelector('[data-vpx-prev]');
      var nextBtn = root.querySelector('[data-vpx-next]');
      var playBtn = root.querySelector('[data-vpx-playpause]');
      var liveRegion = root.querySelector('[data-vpx-live]');
      var toast = root.querySelector('[data-vpx-toast]');

      var idx = 0;
      var isAnimating = false;
      var autoplayEnabled = playBtn !== null;
      var autoplayInterval = parseInt(root.dataset.autoplayMs || '4000', 10);
      var userPaused = false;
      var autoplayTimer = null;
      var toastTimer = null;

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) stage.classList.add('vpx-reduced');

      function isNarrow() {
        return window.innerWidth < 480;
      }

      items.forEach(function (item, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'vpx-carousel__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', String(i + 1));
        dot.addEventListener('click', function () {
          goTo(i);
        });
        if (dotsWrap) dotsWrap.appendChild(dot);
      });
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];

      function render() {
        var narrow = isNarrow();
        var rotUnit = narrow ? 30 : 42;
        var txUnit = narrow ? 88 : 125;
        var tzUnit = narrow ? 110 : 160;
        var maxNeighbors = narrow ? 1 : 2;

        items.forEach(function (item, i) {
          var offset = i - idx;
          if (offset > items.length / 2) offset -= items.length;
          if (offset < -items.length / 2) offset += items.length;

          var abs = Math.abs(offset);
          var clampedOffset = Math.max(-maxNeighbors, Math.min(maxNeighbors, offset));
          var visible = abs <= maxNeighbors;
          var scale = 1 - Math.min(abs, maxNeighbors) * 0.28;
          var rot = clampedOffset * rotUnit;
          var tx = clampedOffset * txUnit;
          var tz = -Math.min(abs, maxNeighbors) * tzUnit;
          var op = visible ? 1 - Math.min(abs, maxNeighbors) * 0.35 : 0;

          item.style.transform =
            'translateX(' + tx + 'px) translateZ(' + tz + 'px) rotateY(' + (-rot) + 'deg) scale(' + scale + ')';
          item.style.opacity = String(op);
          item.style.zIndex = String(10 - abs);
          item.classList.toggle('is-active', i === idx);
          item.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
        });

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === idx);
        });

        if (liveRegion) {
          var activeTitleEl = items[idx].querySelector('.vpx-carousel__item-title');
          var title = activeTitleEl ? activeTitleEl.textContent : '';
          liveRegion.textContent = title + ' — ' + (idx + 1) + ' of ' + items.length;
        }

        if (prevBtn) prevBtn.disabled = isAnimating;
        if (nextBtn) nextBtn.disabled = isAnimating;
      }

      function lockDuring(ms) {
        isAnimating = true;
        render();
        setTimeout(function () {
          isAnimating = false;
          if (prevBtn) prevBtn.disabled = false;
          if (nextBtn) nextBtn.disabled = false;
        }, ms);
      }

      function goTo(newIdx) {
        if (isAnimating) return;
        idx = ((newIdx % items.length) + items.length) % items.length;
        lockDuring(reducedMotion ? 450 : 800);
      }

      function next() { goTo(idx + 1); }
      function prev() { goTo(idx - 1); }

      if (prevBtn) prevBtn.addEventListener('click', function () { restartAutoplayIfNeeded(); prev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { restartAutoplayIfNeeded(); next(); });

      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); restartAutoplayIfNeeded(); next(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); restartAutoplayIfNeeded(); prev(); }
      });

      items.forEach(function (item, i) {
        item.addEventListener('click', function (e) {
          if (item.classList.contains('is-active')) return;
          e.preventDefault();
          restartAutoplayIfNeeded();
          goTo(i);
        });
      });

      var touchStartX = null;
      stage.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        pauseAutoplay();
      }, { passive: true });

      stage.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(dx) > 40) {
          if (dx < 0) next(); else prev();
        }
        resumeAutoplayIfNeeded();
      });

      function startAutoplay() {
        if (!autoplayEnabled || userPaused) return;
        stopAutoplay();
        autoplayTimer = setInterval(next, autoplayInterval);
      }
      function stopAutoplay() {
        clearInterval(autoplayTimer);
      }
      function pauseAutoplay() {
        stopAutoplay();
      }
      function resumeAutoplayIfNeeded() {
        if (!userPaused) startAutoplay();
      }
      function restartAutoplayIfNeeded() {
        if (!autoplayEnabled || userPaused) return;
        stopAutoplay();
        startAutoplay();
      }

      if (autoplayEnabled) {
        root.addEventListener('mouseenter', pauseAutoplay);
        root.addEventListener('mouseleave', resumeAutoplayIfNeeded);

        playBtn.addEventListener('click', function () {
          userPaused = !userPaused;
          var playing = !userPaused;
          playBtn.setAttribute('data-playing', String(playing));
          playBtn.setAttribute('aria-label', playing ? 'Pause autoplay' : 'Play autoplay');
          var pauseIcon = playBtn.querySelector('[data-icon-pause]');
          var playIcon = playBtn.querySelector('[data-icon-play]');
          if (pauseIcon) pauseIcon.style.display = playing ? '' : 'none';
          if (playIcon) playIcon.style.display = playing ? 'none' : '';
          if (playing) startAutoplay(); else stopAutoplay();
        });

        startAutoplay();
      }

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(render, 150);
      });

      function showToast(msg, ok) {
        if (!toast) return;
        toast.textContent = msg;
        toast.style.borderColor = ok ? 'rgba(255,107,53,0.4)' : 'rgba(220,80,80,0.5)';
        toast.hidden = false;
        void toast.offsetWidth;
        toast.classList.add('is-visible');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () {
          toast.classList.remove('is-visible');
          setTimeout(function () { toast.hidden = true; }, 320);
        }, 2400);
      }

      root.querySelectorAll('[data-vpx-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.variantId;
          if (!id) return;
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('cart');
              return res.json();
            })
            .then(function () {
              btn.disabled = false;
              btn.classList.add('is-added');
              var original = btn.textContent;
              btn.textContent = 'Added ✓';
              showToast('Added to cart.', true);
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart:build'));
              setTimeout(function () {
                btn.classList.remove('is-added');
                btn.textContent = original;
              }, 1800);
            })
            .catch(function () {
              btn.disabled = false;
              showToast('Could not add. Try again.', false);
            });
        });
      });

      render();
    }

    function boot() {
      document.querySelectorAll('[data-vpx-carousel]').forEach(initVpxCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorynex-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVpxFooterReveal(root) {
      if (root.dataset.vpxInit === '1') return;
      root.dataset.vpxInit = '1';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-vpx-reveal]'));
      if (!items.length) return;
      if (!('IntersectionObserver' in window)) return;

      items.forEach(function (item, i) {
        item.classList.add('vpx-pre-reveal');
        item.style.transitionDelay = (i * 90) + 'ms';
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('vpx-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      items.forEach(function (item) { observer.observe(item); });

      // Safety net: never let anything stay invisible forever.
      setTimeout(function () {
        items.forEach(function (item) { item.classList.add('vpx-visible'); });
      }, 2500);
    }

    // Mobile accordion for the Shop/Company/Support columns. On desktop
    // (>768px) this does nothing — columns stay fully expanded via CSS,
    // exactly as before. Safe fallback: without JS, .vpx-footer__links
    // has no data-collapsed attribute at all, so it stays visible.
    function initVpxFooterAccordion(root) {
      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-vpx-accordion-trigger]'));
      if (!triggers.length) return;

      function applyForViewport() {
        var isMobile = window.innerWidth <= 768;
        triggers.forEach(function (trigger) {
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          if (!panel) return;

          if (!isMobile) {
            trigger.setAttribute('aria-expanded', 'true');
            panel.removeAttribute('data-collapsed');
            return;
          }

          if (trigger.dataset.vpxAccordionBound !== '1') {
            trigger.dataset.vpxAccordionBound = '1';
            trigger.addEventListener('click', function () {
              var isOpen = trigger.getAttribute('aria-expanded') === 'true';
              trigger.setAttribute('aria-expanded', String(!isOpen));
              panel.setAttribute('data-collapsed', String(isOpen));
            });
          }

          if (!panel.hasAttribute('data-collapsed')) {
            trigger.setAttribute('aria-expanded', 'false');
            panel.setAttribute('data-collapsed', 'true');
          }
        });
      }

      applyForViewport();

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(applyForViewport, 150);
      });
    }

    // Track-order parcel: animates only while the link is on screen (and never with reduced motion).
    function initVpxFooterParcel(root) {
      var link = root.querySelector('.vpx-footer__link--track');
      if (!link || !('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { link.classList.toggle('is-live', entry.isIntersecting); });
      }).observe(link);
    }

    function initVpxFooterMotion(root) {
      if (!('IntersectionObserver' in window)) return;
      root.classList.add('is-offscreen');
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { root.classList.toggle('is-offscreen', !entry.isIntersecting); });
      }, { rootMargin: '200px 0px' }).observe(root);
    }

    function boot() {
      document.querySelectorAll('[data-vpx-footer]').forEach(function (root) {
        initVpxFooterMotion(root);
        initVpxFooterReveal(root);
        initVpxFooterAccordion(root);
        initVpxFooterParcel(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vpx-sport-catalog"] && !Shopify.designMode) return;
  try {
    
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  document.addEventListener('click', function(e){
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      var toggle = e.target.closest('.vpx-sc-card-toggle');
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          if(!toggle) return;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              var card = toggle.closest('.vpx-sc-card');
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  if(!card) return;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      var isOpen = card.classList.contains('vpx-sc-open');
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          document.querySelectorAll('.vpx-sc-card.vpx-sc-open').forEach(function(c){
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                if(c !== card){
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        c.classList.remove('vpx-sc-open');
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                var t = c.querySelector('.vpx-sc-card-toggle');
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        if(t) t.setAttribute('aria-expanded', 'false');
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  });
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      card.classList.toggle('vpx-sc-open', !isOpen);
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          toggle.setAttribute('aria-expanded', String(!isOpen));
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            });
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
  } catch(e) { console.error(e); }
})();
})();
